module.exports = __webpack_public_path__ + "static/media/AQ.4e918604.svg";